var fn = function( obj ){
var __t,__p='';
__p+='#pragma SLOT version\n\n#pragma SLOT definitions\n\n#pragma SLOT precision\n\n'+
( require( "./includes/glsl-compat.frag" )() )+
'\n\n#pragma SLOT pf\n\n\n#if depthFormat( D_RGB )\n  IN vec2 fragZW;\n\n  vec3 encodeDepthRGB(float depth){\n    vec4 c = vec4(1.0,255.0,65025.0,16581375.0)*depth;\n    c=fract(c);\n    c.xyz-=c.yzw*(1.0/255.0);\n    return c.xyz;\n  }\n#endif\n\n\n\nvoid main(void){\n\n  #pragma SLOT f\n\n  #if depthFormat( D_RGB )\n    gl_FragColor.xyz = encodeDepthRGB( ( fragZW.x / fragZW.y ) * 0.5 + 0.5 );\n    gl_FragColor.w=0.0;\n  #endif\n\n  #if depthFormat( D_DEPTH )\n    gl_FragColor = vec4( 0.0 );\n  #endif\n\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;